<template>
    <button
        type="button"
        class="bg-blue rounded-b text-white no-underline block w-full text-center py-3 focus:outline-none focus:shadow-outline"
        @click.prevent="onOpen"
    >
        <div class="inline-flex items-center">
            Acknowledge payment

            <base-svg
                name="icon-cheveron-right"
                class="w-6 h-6 fill-primary-white"
            />
        </div>

        <charges-acknowledge-edit-modal
            v-model="show_modal"
            :charge="charge"
            @success="onSuccess"
        />
    </button>
</template>

<script>
    import ChargesAcknowledgeEditModal from './charges-acknowledge-edit-modal'

    export default {
        components: {
            ChargesAcknowledgeEditModal
        },
        props: {
            charge: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                show_modal: false
            }
        },
        methods: {
            onOpen () {
                setTimeout(() => { this.show_modal = true })
            },
            onSuccess () {
                this.$emit('success')
            }
        }
    }
</script>
